import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';

import { DeltaAtom } from '../../../atoms/icon-atoms/icon-atoms';

const PercentageChange = ({
  currentValue,
  previousValue,
  isFirstYear,
  isDeviated,
  className,
}) => {
  if (typeof currentValue === 'number') {
    return (
      <div className={className}>
        {`${currentValue.toString()}%`}
        {isDeviated && '*'}{' '}
        {isFirstYear || typeof previousValue !== 'number' ? (
          '---'
        ) : (
          <DeltaAtom deltaValue={currentValue - previousValue} />
        )}
      </div>
    );
  } else {
    console.warn(
      `PercentageChange received non valid arguments - currentValue: ${currentValue}, previousValue: ${previousValue}`
    );
    return null;
  }
};

// === PercentageChange CSS ===
const StyledPercentageChange = styled(PercentageChange)`
  display: inline-block;
  font-weight: ${vars.fontWeightRegular};
  ${vars.fontSize4}
`;

export default StyledPercentageChange;
